/**
 * Used with webcomponents to convert a boolean to string.
 * For Example: Convert a boolean property to aria-hidden or aria-expanded.
 * @param {true|false} bool A boolean value to be converted into a string.
 * @returns {'true'|'false'}
 */
export const booleanToString = (bool) => {
	switch (bool) {
		case true:
			return 'true';
		default:
		case false:
			return 'false';
	}
};

/**
 * Used with webcomponents to convert a string boolean to true boolean.
 * @param {'true'|'false'|'TRUE'|'FALSE'} string A string representing 'true' or 'false'
 * @returns {boolean}
 */
export const stringToBoolean = (string) => {
	switch (string) {
		case 'true':
		case 'TRUE':
			return true;
		default:
		case 'false':
		case 'FALSE':
			return false;
	}
};
